<template>
  <button
    class="relative px-3 py-2"
    :class="[selected ? 'bg-primary-400 text-contrast-primary' : '']"
  >
    <span
      v-if="quantityError"
      class="absolute right-1 top-1 block aspect-square h-2 w-2 rounded-full bg-red-600"
    ></span>
    <span>
      {{ value }}
    </span>
  </button>
</template>

<script>
export default {
  name: 'ItemsPaginationButton',
  props: {
    value: {
      type: String,
      required: true
    },
    originalItem: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    quantityError() {
      return (
        this.originalItem.quantity !==
        Object.values(this.originalItem.stock)
          .map((item) => item.quantity)
          .filter((n) => parseInt(n) === n)
          .reduce((a, b) => a + b, 0) +
          this.originalItem.order
      )
    }
  }
}
</script>
